import { ref } from 'vue';

const getVacationOpenRequests = () => {
    const vacationOpenRequest_error = ref(null);
    const vacationOpenRequests = ref(null);

    const loadVacationOpenRequests = async ( monitor_others, view_locations, year) => {
        var params = [];
        params.push(['monitor_others',monitor_others]);
        params.push(['view_locations', view_locations]);
        params.push(['year', year]);
        
        try {
            let data = await fetch("/api/vacationopenrequests?" + new URLSearchParams(params));

            //console.log("data oimapp: " ,data);
            if (!data.ok) {
                throw Error("Can't load data");
            }

            vacationOpenRequests.value = await data.json();
            //console.log(vacationOpenRequests.value);
        } catch (err) {
            vacationOpenRequest_error.value = err.message;
        }
    };
     
    return { vacationOpenRequests, vacationOpenRequest_error, loadVacationOpenRequests};
}

export default getVacationOpenRequests;
